var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-component" },
    [
      _vm.mobileBigAndBelow
        ? _c(
            "v-layout",
            { attrs: { "align-center": "" } },
            [
              _c(
                "v-flex",
                { staticClass: "logo" },
                [
                  _c("router-link", { attrs: { to: "/" } }, [
                    _c("img", {
                      attrs: {
                        src: "/static/images/logo/logo.png",
                        alt: _vm.brand
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header" },
        [
          _c(
            "v-layout",
            { staticClass: "title" },
            [
              _c("v-flex", [
                _c("h1", [_vm._v(_vm._s(_vm.$t("MyAccount.LogInTitle")))])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "close" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "close",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeLoginDialog()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-form",
        {
          staticClass: "form-normal ctsform",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.login()
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loginErrorMessage,
                  expression: "loginErrorMessage"
                }
              ],
              staticClass: "control-block"
            },
            [
              _vm.loginErrorMessage === "PLAYER_NOT_FOUND"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Account.Login.error.PLAYER_NOT_FOUND"))
                    )
                  ])
                : _vm.loginErrorMessage === "USERNAME_CREDENTIAL_INVALID"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Account.Login.error.USERNAME_CREDENTIAL_INVALID"
                        )
                      )
                    )
                  ])
                : _vm.loginErrorMessage === "INVALID_CREDENTIALS"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Account.Login.error.INVALID_CREDENTIALS"))
                    )
                  ])
                : _vm.loginErrorMessage === "InvalidCredentials"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Account.Login.error.InvalidCredentials"))
                    )
                  ])
                : _vm.loginErrorMessage === "PLAYER_NOT_ACTIVATED"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Account.Login.error.PLAYER_NOT_ACTIVATED"))
                    )
                  ])
                : _vm.loginErrorMessage ===
                  "USERNAME_CREDENTIAL_NOT_IN_ACTIVE_STATE"
                ? _c("div", {
                    staticClass: "msg-block tac error",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Account.Login.error.USERNAME_CREDENTIAL_NOT_IN_ACTIVE_STATE"
                        )
                      )
                    }
                  })
                : _vm.loginErrorMessage === "PLAYER_LOCKED"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(_vm._s(_vm.$t("Account.Login.error.PLAYER_LOCKED")))
                  ])
                : _vm.loginErrorMessage === "TC_NOT_ACCEPTED"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Account.Login.error.TC_NOT_ACCEPTED"))
                    )
                  ])
                : _vm.loginErrorMessage === "PLAYER_NOT_ACTIVE"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Account.Login.error.PLAYER_NOT_ACTIVE"))
                    )
                  ])
                : _vm.loginErrorMessage === "INCORRECT_DATA"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(_vm._s(_vm.$t("Account.Login.error.INCORRECT_DATA")))
                  ])
                : _vm.loginErrorMessage === "ACCOUNT_DURING_CLOSURE"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.Login.error.ACCOUNT_DURING_CLOSURE")
                      )
                    )
                  ])
                : _vm.loginErrorMessage === "INCORRECT_PLAYER_LEVEL"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.Login.error.INCORRECT_PLAYER_LEVEL")
                      )
                    )
                  ])
                : _vm.loginErrorMessage === "SESSION_LIMITS_EXCEEDED"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.Login.error.SESSION_LIMITS_EXCEEDED")
                      )
                    )
                  ])
                : _vm.loginErrorMessage === "MISSING_CREDENTIALS"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Account.Login.error.MISSING_CREDENTIALS"))
                    )
                  ])
                : _vm.loginErrorMessage === "SESSION_HANDLING_FAILURE"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.Login.error.SESSION_HANDLING_FAILURE")
                      )
                    )
                  ])
                : _vm.loginErrorMessage === "SESSION_HANDLING_SYSTEM_FAILURE"
                ? _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Account.Login.error.SESSION_HANDLING_SYSTEM_FAILURE"
                        )
                      )
                    )
                  ])
                : _vm.loginErrorMessage === "MISSING_OR_UNKNOWN_ERROR_CODE"
                ? _c("div", {
                    staticClass: "msg-block tac error",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Account.Login.error.MISSING_OR_UNKNOWN_ERROR_CODE"
                        )
                      )
                    }
                  })
                : _c("div", { staticClass: "msg-block tac error" }, [
                    _vm._v(_vm._s(_vm.$t("Account.Login.error.other")))
                  ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "control-block clearafter",
              class: { filled: _vm.loginFields.username.length > 0 }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.loginFields.username,
                    expression: "loginFields.username"
                  }
                ],
                ref: "username",
                attrs: {
                  type: "text",
                  autocomplete: "off",
                  name: "username",
                  id: "username",
                  required: "",
                  autofocus: ""
                },
                domProps: { value: _vm.loginFields.username },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.loginFields, "username", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { staticClass: "control-label" }, [
                _vm._v(_vm._s(_vm.$t("Account.Login.email")))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "control-block clearafter",
              class: { filled: _vm.loginFields.password.length > 0 }
            },
            [
              (_vm.loginFields.showPassword ? "text" : "password") ===
              "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginFields.password,
                        expression: "loginFields.password"
                      }
                    ],
                    attrs: {
                      autocomplete: "off",
                      name: "password",
                      id: "password",
                      required: "",
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.loginFields.password)
                        ? _vm._i(_vm.loginFields.password, null) > -1
                        : _vm.loginFields.password
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.loginFields.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.loginFields,
                                "password",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.loginFields,
                                "password",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.loginFields, "password", $$c)
                        }
                      }
                    }
                  })
                : (_vm.loginFields.showPassword ? "text" : "password") ===
                  "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginFields.password,
                        expression: "loginFields.password"
                      }
                    ],
                    attrs: {
                      autocomplete: "off",
                      name: "password",
                      id: "password",
                      required: "",
                      type: "radio"
                    },
                    domProps: {
                      checked: _vm._q(_vm.loginFields.password, null)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.loginFields, "password", null)
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginFields.password,
                        expression: "loginFields.password"
                      }
                    ],
                    attrs: {
                      autocomplete: "off",
                      name: "password",
                      id: "password",
                      required: "",
                      type: _vm.loginFields.showPassword ? "text" : "password"
                    },
                    domProps: { value: _vm.loginFields.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.loginFields,
                          "password",
                          $event.target.value
                        )
                      }
                    }
                  }),
              _vm._v(" "),
              _c("label", { staticClass: "control-label" }, [
                _vm._v(_vm._s(_vm.$t("Account.Login.password")))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "show_hide",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.toggleShowPassword()
                }
              }
            },
            [_vm._v(_vm._s(_vm.loginFields.showPassword ? "Hide" : "Show"))]
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { staticClass: "float-right forgot_pass", attrs: { xs12: "" } },
                [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToResetPassword()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("MyAccount.ForgotPass")))
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.formSubmitSppiner
            ? _c("div", [_c("circle-loader")], 1)
            : _vm._e(),
          _vm._v(" "),
          !_vm.formSubmitSppiner
            ? _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue join",
                      attrs: { block: "" },
                      on: {
                        click: function($event) {
                          return _vm.goToRegistrationPage()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.JoinNow")))])]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue login",
                      attrs: {
                        type: "submit",
                        disabled: _vm.isLoginButtonDisabled,
                        block: ""
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("MyAccount.LogIn")))])]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1962778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1962778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/LoginComponent.vue
// module id = null
// module chunks = 